import { render, staticRenderFns } from "./bgys-file-manager-view.vue?vue&type=template&id=31054dbb&scoped=true"
import script from "./bgys-file-manager-view.vue?vue&type=script&lang=js"
export * from "./bgys-file-manager-view.vue?vue&type=script&lang=js"
import style0 from "./bgys-file-manager-view.vue?vue&type=style&index=0&id=31054dbb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31054dbb",
  null
  
)

export default component.exports